export default "__VITE_ASSET__BlBKDwiE__"